import React from "react";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  // {
  //   key: "register",
  //   path: `${AUTH_PREFIX_PATH}/register`,
  //   component: React.lazy(
  //     () => import("views/auth-views/authentication/register"),
  //   ),
  // },
  //   https://qa-2.teamsunday.com/follow-up?value=Yes&question_id=9&email_id=1&appointment_id=1
  {
    key: "follow-up-questionnaire",
    path: `${APP_PREFIX_PATH}/follow-up`,
    component: React.lazy(
      () => import("views/app-views/follow-up-questionnaire"),
    ),
  },
  {
    key: "register-token",
    path: `${AUTH_PREFIX_PATH}/invitation`,
    component: React.lazy(
      () => import("views/auth-views/authentication/register-token"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
  {
    key: "confirm-password",
    path: `${AUTH_PREFIX_PATH}/password-confirmation`,
    component: React.lazy(
      () => import("views/auth-views/authentication/confirm-password"),
    ),
  },
  {
    key: "redeem-campaign",
    path: `${APP_PREFIX_PATH}/redeem-campaign`,
    component: React.lazy(() => import("views/app-views/redeem-campaign")),
  },
  {
    key: "event-campaign",
    path: `${APP_PREFIX_PATH}/event-campaign`,
    component: React.lazy(() => import("views/app-views/event-campaign")),
  },
  {
    key: "cancel-user-invitation",
    path: `${AUTH_PREFIX_PATH}/cancel-invitation`,
    component: React.lazy(() => import("views/app-views/cancel-invitation")),
  },
];

export const inactiveCompanyRoutes = [
  {
    key: "inactive-company-warning",
    path: `${APP_PREFIX_PATH}/company-inactive`,
    component: React.lazy(() => import("views/app-views/company-inactive")),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.analytic",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/dashboards/analytic")),
  },
  {
    key: "redeem-campaign",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/redeem-campaign`,
    component: React.lazy(() => import("views/app-views/redeem-campaign")),
  },
  {
    key: "event-campaign",
    isRenderedFullPage: true,
    path: `${APP_PREFIX_PATH}/event-campaign`,
    component: React.lazy(() => import("views/app-views/event-campaign")),
  },
  {
    key: "follow-up-questionnaire",
    path: `${APP_PREFIX_PATH}/follow-up`,
    component: React.lazy(
      () => import("views/app-views/follow-up-questionnaire-app"),
    ),
  },
  {
    key: "followUp.campaigns",
    path: `${APP_PREFIX_PATH}/follow-ups-templates`,
    component: React.lazy(() => import("views/app-views/follow-ups/templates")),
  },
  {
    key: "followUp.schedules",
    path: `${APP_PREFIX_PATH}/follow-ups-schedules`,
    component: React.lazy(() => import("views/app-views/follow-ups/schedules")),
  },
  {
    key: "dashboard.integrations",
    path: `${APP_PREFIX_PATH}/integrations/:id`,
    component: React.lazy(
      () => import("views/app-views/select-integration-products"),
    ),
  },
  {
    key: "users.invitations.accept",
    path: `${AUTH_PREFIX_PATH}/invitation`,
    component: React.lazy(() => import("views/app-views/user-invitation")),
  },
  {
    key: "dashboard.integrations.select-products",
    path: `${APP_PREFIX_PATH}/integrations`,
    component: React.lazy(() => import("views/app-views/integrations")),
  },
  {
    key: "dashboard.notifications",
    path: `${APP_PREFIX_PATH}/notifications`,
    component: React.lazy(() => import("views/app-views/notifications-page")),
  },
  {
    key: "users.invitations",
    path: `${APP_PREFIX_PATH}/user-invitations`,
    component: React.lazy(() => import("views/app-views/user-invitations")),
  },
  {
    key: "dashboard.companies",
    path: `${APP_PREFIX_PATH}/company`,
    component: React.lazy(() => import("views/app-views/edit-company")),
  },
  {
    key: "dashboard.products",
    path: `${APP_PREFIX_PATH}/products`,
    component: React.lazy(() => import("views/app-views/product-list")),
  },
  {
    key: "dashboard.packages",
    path: `${APP_PREFIX_PATH}/packages`,
    component: React.lazy(() => import("views/app-views/packages-list")),
  },
  {
    key: "dashboard.inventory-reorder",
    path: `${APP_PREFIX_PATH}/inventory-reorder`,
    component: React.lazy(() => import("views/app-views/inventory-reorder")),
  },
  {
    key: "dashboard.create-inventory-reorder",
    path: `${APP_PREFIX_PATH}/inventory-reorder/create`,
    component: React.lazy(() => import("views/app-views/create-inventory-reorder")),
  },
  {
    key: "dashboard.edit-packages",
    path: `${APP_PREFIX_PATH}/packages/:id`,
    component: React.lazy(() => import("views/app-views/edit-package")),
  },
  {
    key: "apps.ecommerce.edit-product",
    path: `${APP_PREFIX_PATH}/products/:id`,
    component: React.lazy(() => import("views/app-views/edit-product")),
  },
  {
    key: "apps.ecommerce.add-products",
    path: `${APP_PREFIX_PATH}/products/create`,
    component: React.lazy(() => import("views/app-views/add-product")),
  },
  {
    key: "apps.ecommerce.shipments",
    path: `${APP_PREFIX_PATH}/shipments`,
    component: React.lazy(() => import("views/app-views/shipments")),
  },
  {
    key: "apps.ecommerce.shipments-edit",
    path: `${APP_PREFIX_PATH}/shipments/:id/edit`,
    component: React.lazy(() => import("views/app-views/edit-shipment")),
  },
  {
    key: "apps.ecommerce.shipments-create-custom",
    path: `${APP_PREFIX_PATH}/shipments/create-custom`,
    component: React.lazy(
      () => import("views/app-views/create-custom-shipment"),
    ),
  },
  {
    key: "apps.ecommerce.shipments-create",
    path: `${APP_PREFIX_PATH}/shipments/send-packages`,
    component: React.lazy(
      () => import("views/app-views/create-packages-shipment"),
    ),
  },
  {
    key: "apps.ecommerce.shipments-create-bulk",
    path: `${APP_PREFIX_PATH}/shipments/send-bulk`,
    component: React.lazy(() => import("views/app-views/create-bulk-shipment")),
  },
  {
    key: "apps.ecommerce.shipments-create-file",
    path: `${APP_PREFIX_PATH}/shipments/send-file`,
    component: React.lazy(() => import("views/app-views/create-file-shipment")),
  },
  {
    key: "apps.ecommerce.shipment-view",
    path: `${APP_PREFIX_PATH}/shipments/:id`,
    component: React.lazy(() => import("views/app-views/view-shipment")),
  },
  {
    key: "pages.settings",
    path: `${APP_PREFIX_PATH}/settings/*`,
    component: React.lazy(() => import("views/app-views/settings")),
  },
  {
    key: "pages.users",
    path: `${APP_PREFIX_PATH}/users`,
    component: React.lazy(() => import("views/app-views/user-list")),
  },
  {
    key: "pages.users-invitations",
    path: `${APP_PREFIX_PATH}/users-invite`,
    component: React.lazy(() => import("views/app-views/users-invite")),
  },
  {
    key: "pages.campaigns",
    path: `${APP_PREFIX_PATH}/campaigns`,
    component: React.lazy(() => import("views/app-views/campaigns")),
  },
  {
    key: "apps.campaigns.edit-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/:id`,
    component: React.lazy(() => import("views/app-views/edit-campaign")),
  },
  {
    key: "apps.merch-metrics-analytics",
    path: `${APP_PREFIX_PATH}/analytics`,
    component: React.lazy(
      () => import("views/app-views/merch-metrics-analytics"),
    ),
  },
  {
    key: "apps.campaigns.campaign-analytics",
    path: `${APP_PREFIX_PATH}/campaigns/:id/analytics`,
    component: React.lazy(() => import("views/app-views/campaign-analytics")),
  },
  {
    key: "apps.campaigns.edit-redeem-campaign",
    path: `${APP_PREFIX_PATH}/redeem-campaigns/:id`,
    component: React.lazy(() => import("views/app-views/edit-redeem-campaign")),
  },
  {
    key: "apps.campaigns.edit-event-campaign",
    path: `${APP_PREFIX_PATH}/event-campaigns/:id`,
    component: React.lazy(() => import("views/app-views/edit-event-campaign")),
  },
  {
    key: "apps.campaigns.create-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/create`,
    component: React.lazy(() => import("views/app-views/create-campaign")),
  },
  {
    key: "apps.campaigns.create-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/create-redeem`,
    component: React.lazy(
      () => import("views/app-views/create-shipping-campaign"),
    ),
  },
  {
    key: "apps.campaigns.create-event-campaign",
    path: `${APP_PREFIX_PATH}/campaigns/create-event`,
    component: React.lazy(
      () => import("views/app-views/create-event-campaign"),
    ),
  },
  {
    key: "pages.closets",
    path: `${APP_PREFIX_PATH}/closets`,
    component: React.lazy(() => import("views/app-views/closets")),
  },
  {
    key: "pages.closets.edit-closet",
    path: `${APP_PREFIX_PATH}/closets/:id`,
    component: React.lazy(() => import("views/app-views/edit-closet")),
  },
  {
    key: "pages.closets.create-closet",
    path: `${APP_PREFIX_PATH}/closets/create`,
    component: React.lazy(() => import("views/app-views/create-closet")),
  },
  {
    key: "pages.recipients",
    path: `${APP_PREFIX_PATH}/recipients`,
    component: React.lazy(() => import("views/app-views/recipients")),
  },
  {
    key: "pages.closets.create-recipient",
    path: `${APP_PREFIX_PATH}/recipients/create`,
    component: React.lazy(() => import("views/app-views/create-recipient")),
  },
  {
    key: "pages.closets.edit-recipient",
    path: `${APP_PREFIX_PATH}/recipients/:id`,
    component: React.lazy(() => import("views/app-views/edit-recipient")),
  },
  {
    key: "pages.closets.recipient-shipments",
    path: `${APP_PREFIX_PATH}/recipients/:id/shipments`,
    component: React.lazy(() => import("views/app-views/recipient-shipments")),
  },
  {
    key: "pages.closets.create-recipient-address",
    path: `${APP_PREFIX_PATH}/recipients/:id/create`,
    component: React.lazy(
      () => import("views/app-views/create-recipient-address"),
    ),
  },
  {
    key: "pages.closets.edit-recipient-address",
    path: `${APP_PREFIX_PATH}/recipients/:id/address/:address_id`,
    component: React.lazy(
      () => import("views/app-views/edit-recipient-address"),
    ),
  },
  {
    key: "pages.errors.404",
    path: `${APP_PREFIX_PATH}/error/404`,
    component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  },
  {
    key: "pages.campaigns.emails",
    path: `${APP_PREFIX_PATH}/campaigns/:id/emails`,
    component: React.lazy(() => import("views/app-views/campaign-emails")),
  },
];

export const fullPageProtectedRoutePaths = protectedRoutes
  .filter((route) => route.isRenderedFullPage)
  ?.map((route) => route.path.replace(APP_PREFIX_PATH, ""));
